import { useState } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { CheckIcon } from '@/components/icons'

const MetricsPicker = ({ children, allMetrics = [], currentMetric = null, onMetricSelect }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [isOpen, setIsOpen] = useState(false)

    const handleMetricSelect = (metric) => {
        onMetricSelect(metric)
        setIsOpen(false)
        setSearchTerm('')
    }

    // Filter metrics based on search term and ensure current metric is first
    const filteredMetrics = allMetrics
        .filter((metric) => metric.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
            // Put current metric first
            if (currentMetric?.id === a.id) return -1
            if (currentMetric?.id === b.id) return 1
            return 0
        })

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>{children}</PopoverTrigger>
            <PopoverContent
                className="tw:w-80 tw:p-0 tw:bg-primary tw:border-slate-700 tw:text-white tw:p-2"
                align="end"
                side="bottom"
            >
                {/* Search */}
                <div className="tw:pb-2">
                    <div className="tw:relative">
                        <Search className="tw:absolute tw:left-3 tw:top-1/2 tw:transform tw:-translate-y-1/2 tw:text-slate-400 tw:h-4 tw:w-4" />
                        <Input
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="tw:pl-9 tw:bg-slate-700 tw:border-slate-600 tw:text-white tw:placeholder-slate-400 tw:text-sm tw:h-8"
                        />
                    </div>
                </div>

                {/* Metrics List */}
                <div className="tw:max-h-64 tw:overflow-y-auto">
                    {filteredMetrics.map((metric) => (
                        <div
                            key={metric.id}
                            className="tw:px-0.5 tw:py-2 tw:hover:bg-gray-500 tw:cursor-pointer tw:transition-colors tw:rounded-lg"
                            onClick={() => handleMetricSelect(metric)}
                        >
                            <div className="tw:flex tw:items-center tw:gap-1.5 tw:items-center">
                                {currentMetric?.id === metric.id && (
                                    <CheckIcon className="tw:text-gray-200 tw:h-5 tw:w-5" />
                                )}
                                {currentMetric?.id !== metric.id && <div className="tw:h-5 tw:w-5" />}
                                <span className="tw:text-sm tw:text-white">{metric.name}</span>
                            </div>
                        </div>
                    ))}
                    {filteredMetrics.length === 0 && (
                        <div className="tw:px-4 tw:py-6 tw:text-center tw:text-slate-400 tw:text-sm">
                            No metrics found
                        </div>
                    )}
                </div>
            </PopoverContent>
        </Popover>
    )
}

export default MetricsPicker
